import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

export const useTaxPortal = () => {
  const { instance: msalInstance, accounts } = useMsal();
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const [dialNumber, setDialNumber] = useState("+1");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isDialerOpen, setIsDialerOpen] = useState(false);
  const [emailModalConfig, setEmailModalConfig] = useState(null);

  const account = accounts[0];

  useEffect(() => {
    let isMounted = true;
    const initializeMsal = async () => {
      try {
        // handleRedirectPromise should be called on app start
        await msalInstance.handleRedirectPromise();
      } catch (err) {
        console.error('MSAL Initialization Error:', err);
        if (isMounted) setError('Failed to initialize authentication.');
      } finally {
        if (isMounted) setIsInitialized(true);
      }
    };
    initializeMsal();
    return () => { isMounted = false; };
  }, [msalInstance]);

  const handleLogin = async () => {
    if (!isInitialized) {
      setError('Authentication is still initializing. Please wait.');
      return;
    }
    if (!process.env.REACT_APP_MSAL_CLIENT_ID || process.env.REACT_APP_MSAL_CLIENT_ID === 'YOUR_CLIENT_ID_HERE') {
      setError('Please configure REACT_APP_MSAL_CLIENT_ID in your .env file with your Azure AD application client id.');
      return;
    }
    setError('');
    setMessage('');
    try { await msalInstance.loginRedirect(loginRequest); } catch (e) { setError(e.message || 'Microsoft sign-in failed.'); }
  };

  const handleLogout = async () => {
    try { await msalInstance.logoutRedirect({ account }); } catch (e) { setError(e.message || 'Logout failed.'); }
  };

  return {
    msalInstance, account, isInitialized,
    error, setError, message, setMessage,
    handleLogin, handleLogout,
    dialNumber, setDialNumber,
    refreshTrigger, setRefreshTrigger,
    isDialerOpen, setIsDialerOpen,
    emailModalConfig, setEmailModalConfig
  };
};